export default "__VITE_ASSET__BZgFjIiH__"